import Box from '@mui/material/Box';
import React from 'react';
import { PaypalBanner } from '@rakutenfrance/shared-svg';
import * as s from './PaypalPanel.style';
import { paypalUrl } from '../../../constants';
export const PaypalPanel = () => {
    return (React.createElement(Box, { sx: s.container },
        React.createElement(Box, { sx: s.banner },
            React.createElement(PaypalBanner, null)),
        React.createElement(Box, null,
            React.createElement(Box, { sx: s.subtitle, component: 'h4' }, "Sans frais"),
            React.createElement(Box, null, "Le paiement en 4X est sans frais suppl\u00E9mentaires pour toute mise \u00E0 disposition ce financement.")),
        React.createElement(Box, null,
            React.createElement("br", null),
            React.createElement(Box, { sx: s.subtitle, component: 'h4' }, "Souple et flexible"),
            React.createElement(Box, null, "Vos achats peuvent facilement \u00EAtre r\u00E9gl\u00E9s en 4X. Vous pouvez afficher et g\u00E9rer vos dates d'\u00E9ch\u00E9ances depuis votre application Paypal."),
            React.createElement(Box, null,
                "Pour en savoir plus sur le paiement en 4X, rendez-vous ici :",
                React.createElement(Box, { sx: s.linkText, component: 'a', href: paypalUrl, target: "_blank", rel: "noopener noreferrer" },
                    ' ',
                    paypalUrl)),
            React.createElement(Box, null, "Le paiement en 4X est soumis \u00E0 acceptation, pour les achats compris entre 30\u20AC et 2 000\u20AC."))));
};
